import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title-general',
  templateUrl: './title-general.component.html',
  styleUrls: ['./title-general.component.css']
})
export class TitleGeneralComponent {
  @Input('title') title: string = "";

}
